import { render } from "./SubdomainLink.vue?vue&type=template&id=47402b43"
import script from "./SubdomainLink.vue?vue&type=script&lang=js"
export * from "./SubdomainLink.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bliss.audio/bliss.audio/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__